import { worldImageSource, type WorldDocument } from '@private-fiction/story-core';
export function currentSceneLocation(documents: readonly WorldDocument[]): WorldDocument | undefined {
  documents = documents.filter(doc => !doc.deletedAt);
  const character = documents.find(doc => doc.kind === 'character' && doc.runtimeState?.isPlayer === true)
    ?? documents.find(doc => doc.kind === 'character' && (doc.runtimeState?.role ?? doc.fields.role) === 'player_character')
    ?? documents.find(doc => doc.kind === 'character');
  const id = character?.references.find(ref => ref.relation === 'current_location')?.targetId
    ?? documents.find(doc => doc.kind === 'scene' && (doc.runtimeState?.status ?? doc.fields.status) === 'active')?.references.find(ref => ref.relation === 'located_at')?.targetId;
  // An unresolved current location must not jump to an unrelated location image.
  return id ? documents.find(doc => doc.kind === 'location' && doc.id === id) : documents.find(doc => doc.kind === 'location');
}
export function resolveSceneBackdrop(currentImage: string, lastImage: string, covers: readonly (string | undefined)[]): string {
  return currentImage || lastImage || covers.find(Boolean) || '';
}

export function currentSceneImage(documents: readonly WorldDocument[]): string {
  const location = currentSceneLocation(documents);
  const shots = documents.filter(doc => doc.kind === 'scene_image' && !doc.deletedAt && doc.references.some(ref => ref.relation === 'located_at' && ref.targetId === location?.id) && worldImageSource(doc)).sort((a,b) => b.createdAt.localeCompare(a.createdAt));
  return worldImageSource(shots[0]) || worldImageSource(location);
}
